// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__62Spi","isActive":"styles_isActive__xRruG","message":"styles_message__NYiYh","close":"styles_close__s57w_"};